<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()">{{ 'core.done' | translate }}</ion-button>
    </ion-buttons>

    <ion-title>{{ license.artifact }}</ion-title>

    <ion-buttons slot="secondary">
      <ion-button (click)="wrapLicenseTexts=!wrapLicenseTexts">
        <ion-icon slot="icon-only" [name]="wrapLicenseTexts ? 'document-text-outline' : 'document-outline'" [attr.aria-label]="'settings.information.licenses.wrap' | translate"></ion-icon>
      </ion-button>
      <ion-button (click)="openURL(license.url)" [attr.aria-label]="'core.homepage' | translate">
        <ion-icon slot="icon-only" name="link-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h2>{{ 'settings.information.licenses.artifact' | translate }}</h2>
  <pre>{{ license.artifact }}</pre>

  @if (license.group) {
    <h2>{{ 'settings.information.licenses.artifactGroup' | translate }}</h2>
  }
  @if (license.group) {
    <pre>{{ license.group }}</pre>
  }

  @if (license.description) {
    <h2>{{ 'settings.information.licenses.description' | translate }}</h2>
  }
  @if (license.description) {
    <p  class="ion-text-wrap">
      {{ license.description }}
    </p>
  }

  <h2>{{ 'settings.information.licenses.licensedBy' | translate }}</h2>
  <ul>
    @for (l of license.licenses; track l) {
      <li>
        {{l.name}}
        @if (l.url) {
          <a href="{{l.url}}" target="_blank">(Link)</a>
        }
        @if (l.comments) {
          <pre [style.white-space]="wrapLicenseTexts ? 'pre-wrap' : 'pre'">{{ l.comments }}</pre>
        }
      </li>
    }
  </ul>

  @if (license.repository) {
    <h2>{{ 'settings.information.licenses.licenseSource' | translate }}</h2>
  }
  @if (license.repository) {
    <a [href]="license.repository">{{ license.repository }}</a>
  }

  @if (license.artifactNotice) {
    <h2>{{'settings.information.licenses.notice' | translate}}</h2>
  }
  @if (license.artifactNotice) {
    <pre [style.white-space]="wrapLicenseTexts ? 'pre-wrap' : 'pre'">{{ license.artifactNotice }}</pre>
  }

  <h2>{{'settings.information.licenses.licenseText' | translate}}</h2>
  <pre [style.white-space]="wrapLicenseTexts ? 'pre-wrap' : 'pre'">{{ license.artifactLicense }}</pre>

  @if (license.thirdPartyLicenses) {
    <h2>{{'settings.information.licenses.licenseExtended' | translate}}</h2>
  }
  @if (license.thirdPartyLicenses) {
    <pre [style.white-space]="wrapLicenseTexts ? 'pre-wrap' : 'pre'">{{ license.thirdPartyLicenses }}</pre>
  }
</ion-content>
